module.exports = __webpack_public_path__ + "img/45_30.f9ba36dd.png";